import { useState } from "react";
import { Controller } from "react-hook-form";
import { TextField, Box, Popover, ColorPicker, hsbToHex, InlineError } from "@shopify/polaris";
import Stack from "../../Stack";

function RHFColorPicker({ name, control, ...other }) {
  const [popoverActive, setPopoverActive] = useState(false);

  const togglePopover = () => setPopoverActive((active) => !active);

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { value, onChange }, fieldState: { error } }) => {
        const handleColorChange = (newColor) => {
          const hex = hsbToHex(newColor);
          onChange(hex);
        };

        return (
          <Box>
            <Stack alignItems="flex-end" spacing={1} flexWrap="nowrap">
              <Box width="100%">
                <TextField value={value} onChange={onChange} autoComplete="off" error={Boolean(error)} {...other} />
              </Box>

              <Popover
                active={popoverActive}
                activator={
                  <Box
                    style={{
                      backgroundColor: value,
                      height: "32px",
                      width: "40px",
                      cursor: "pointer",
                      borderRadius: "4px",
                      border: "2px solid rgb(255, 255, 255)",
                      boxShadow: "rgba(0, 0, 0, 0.1) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 0px 0px 1px inset",
                    }}
                    onClick={togglePopover}
                  />
                }
                onClose={togglePopover}
              >
                <Box padding="4">
                  <ColorPicker
                    onChange={handleColorChange}
                    color={value ? hexToHsb(value) : { hue: 0, brightness: 0, saturation: 0 }}
                  />
                </Box>
              </Popover>
            </Stack>
            {error && <InlineError message={error.message} fieldID={name} />}
          </Box>
        );
      }}
    />
  );
}

export default RHFColorPicker;

function hexToHsb(hex) {
  let r = 0,
    g = 0,
    b = 0;
  if (hex.length === 7) {
    r = parseInt(hex.slice(1, 3), 16);
    g = parseInt(hex.slice(3, 5), 16);
    b = parseInt(hex.slice(5, 7), 16);
  }
  return rgbToHsb(r, g, b);
}

function rgbToHsb(r, g, b) {
  let max = Math.max(r, g, b),
    min = Math.min(r, g, b);
  let h = 0,
    s = max === 0 ? 0 : (max - min) / max,
    v = max / 255;
  if (max !== min) {
    let d = max - min;
    h = max === r ? (g - b) / d + (g < b ? 6 : 0) : max === g ? (b - r) / d + 2 : (r - g) / d + 4;
    h /= 6;
  }
  return { hue: h * 360, saturation: s, brightness: v };
}
